import { SortDirType } from "../../../common/SortDirType";
import { SortParams } from "../../../common/SortParams";

export const sortByFields = [
  { label: "Supplier Company Name", value: "SUPPLIER_COMPANY_NAME" },
  { label: "Location Name", value: "LOCATION_NAME" },
  { label: "Payout Initiated Date", value: "CREATED_ON" },
  { label: "Payout Completed Date", value: "COMPLETED_ON" },
  { label: "Status", value: "STATUS" },
  { label: "Gross Amount", value: "GROSS_AMOUNT" },
  { label: "Buyer Amount", value: "BUYER_AMOUNT" },
  { label: "Supplier Amount", value: "SUPPLIER_AMOUNT" },
  { label: "Payment Processor Amount", value: "PAYMENT_PROCESSOR_AMOUNT" },
  { label: "Securspace Amount", value: "SECURSPACE_AMOUNT" },
] as const satisfies Array<{label: string, value: string}>;

export type AdminPayoutSortByType = typeof sortByFields[number]['value'];

export interface AdminPayoutSortParams extends SortParams {
  sortBy?: AdminPayoutSortByType;
  sortDir?: SortDirType
}